import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { VincularCardComponent } from './vincular-card/vincular-card.component';
import { CardNoNameComponent } from './card-no-name.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';

const routes: Routes = [{
  path: '',
  component: CardNoNameComponent,
  children: [
    {
      path: 'vincular-card',
      component: VincularCardComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['VINCULAR']},
    },

  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class CardNoNameRoutingModule { }

export const routedComponents = [
  CardNoNameComponent,
  VincularCardComponent,

];
